/** Money is integer sen end to end; these helpers never use floating point for amounts. */

export function formatRM(sen: number): string {
  const sign = sen < 0 ? '-' : '';
  const abs = Math.abs(sen);
  const ringgit = Math.floor(abs / 100).toLocaleString('en-MY');
  return `${sign}RM ${ringgit}.${String(abs % 100).padStart(2, '0')}`;
}

/** "45", "45.5", "45.50", "1,234.05" → sen. Null when it is not a valid amount. */
export function parseRM(input: string): number | null {
  const s = input
    .trim()
    .replace(/^RM\s*/i, '')
    .replace(/,/g, '');
  const m = /^(\d{1,7})(?:\.(\d{1,2}))?$/.exec(s);
  if (!m) return null;
  const cents = (m[2] ?? '').padEnd(2, '0');
  return Number(m[1]) * 100 + Number(cents);
}

/** Sen as an editable "45.50" string. */
export function senToInput(sen: number): string {
  return `${Math.floor(sen / 100)}.${String(sen % 100).padStart(2, '0')}`;
}
